import { Box, CircularProgress, Grid, Typography } from '@mui/material'

interface Props {
    message?: string
}

export default function SplashPage({ message = 'Loading...' }: Props) {
    return (
        <Grid
            container
            direction="column"
            justifyContent="center"
            alignItems="center"
            justifySelf="center"
            style={{
                minHeight: '100vh',
            }}
        >
            <CircularProgress size={60} />
            <Box mt={2}>
                <Typography variant="h5">{message}</Typography>
            </Box>
        </Grid>
    )
}
